(function () {
    function uniqueId() {
      return "new_" + Date.now().toString() + "_" + Math.floor(Math.random() * 100000).toString();
    }
  
    function addNestedFields(buttonId, templateId, containerId) {
      var button = document.getElementById(buttonId);
      var template = document.getElementById(templateId);
      var container = document.getElementById(containerId);
  
      if (!button || !template || !container) return;
  
      button.addEventListener("click", function () {
        var html = template.innerHTML.replace(/NEW_RECORD/g, uniqueId());
        container.insertAdjacentHTML("beforeend", html);
      });
    }
  
    function bindRemoveNestedFields(scope) {
      scope.addEventListener("click", function (event) {
        var button = event.target.closest(".remove-nested-fields");
        if (!button) return;
  
        var wrapper = button.closest(".nested-fields");
        if (!wrapper) return;
  
        var destroyField = wrapper.querySelector(".destroy-flag");
  
        if (destroyField) {
          destroyField.value = "1";
          wrapper.style.display = "none";
        } else {
          wrapper.remove();
        }
      });
    }
  
    function initPbProductsForm() {
      var form = document.querySelector("form[action*='/pb_products']");
      if (!form) return;
  
      addNestedFields(
        "add_pb_serial_number",
        "pb_serial_number_template",
        "pb_serial_numbers_container"
      );
  
      addNestedFields(
        "add_pb_expected_hour",
        "pb_expected_hour_template",
        "pb_expected_hours_container"
      );
  
      bindRemoveNestedFields(form);
    }
  
    document.addEventListener("turbolinks:load", initPbProductsForm);
  })();